import {PigmentThemeProvider} from '@customink/pigment-react';
import {Provider as RollbarProvider} from '@rollbar/react';
import React from 'react';
import {QueryClientProvider} from 'react-query';
import queryClient from '../../../src/shared/queryClient';

const ProvidersWrapper = ({children}) => {
  return (
    <RollbarProvider>
      <PigmentThemeProvider>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </PigmentThemeProvider>
    </RollbarProvider>
  );
};

export default ProvidersWrapper;
